import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ceb4967"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-article" }
const _hoisted_2 = { class: "row g-5" }
const _hoisted_3 = { class: "col-12 col-md-8 col-lg-9" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "meta" }
const _hoisted_6 = {
  key: 0,
  class: "author"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "col-12 col-md-4 col-lg-3" }
const _hoisted_9 = { class: "subtitle" }
const _hoisted_10 = { class: "reset-ul list-articles" }
const _hoisted_11 = { class: "section-think-helpful" }

import { useRoute } from 'vue-router';
  import { request } from '@/utils';
  import { onMounted, ref, inject, ComputedRef, Ref } from 'vue';
  import { IArticle, getArticleDefaultData } from '@/types/article';
  import { FaqSectionArticlesStore } from '@/stores';
  import { IFaqSection } from '@/types/faq-section';
  import { useI18n } from 'vue-i18n';
  import CardArticle from './components/card-article.vue';
  import ThinkHelpful from './components/think-helpful.vue';
  import Like from './components/like.vue';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();

  const faqSectionArticlesStore = inject('faqSectionArticlesStore') as Ref<FaqSectionArticlesStore>;
  const currentSection = inject('currentSection') as ComputedRef<IFaqSection>;

  const { params: { slug } } = useRoute();
  const article = ref<IArticle>(getArticleDefaultData());
  async function fetchArticle() {
    const { data } = await request.get<IArticle>(`/articles/${slug}`);
    article.value = data;
  }
  onMounted(fetchArticle);

  function handlePageChange(page: number) {
    faqSectionArticlesStore.value.fetchData({ page });
  }


return (_ctx: any,_cache: any) => {
  const _component_AppBreadcurmb = _resolveComponent("AppBreadcurmb")!
  const _component_AppTimeFormat = _resolveComponent("AppTimeFormat")!
  const _component_AppSocialShare = _resolveComponent("AppSocialShare")!
  const _component_AppPagination = _resolveComponent("AppPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppBreadcurmb, {
      class: "breadcurmb",
      routes: [
        {
          name: 'Home', to: { name: 'home' }
        },
        {
          name: _unref(currentSection).title, to: { name: 'faq.section', params: { id: _unref(currentSection).id } }
        },
        {
          name: article.value.title
        }
      ]
    }, null, 8, ["routes"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, [
          _createTextVNode(_toDisplayString(article.value.title) + " ", 1),
          _createVNode(Like, {
            modelValue: article.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((article).value = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (article.value.author)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(article.value.author), 1))
            : _createCommentVNode("", true),
          _createElementVNode("span", null, [
            _createVNode(_component_AppTimeFormat, {
              time: article.value.updated_at,
              format: "YYYY.MM.DD HH:mm"
            }, null, 8, ["time"])
          ])
        ]),
        _createElementVNode("div", {
          class: "rich-text",
          innerHTML: article.value.content
        }, null, 8, _hoisted_7),
        _createVNode(_component_AppSocialShare, { class: "share" })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("h5", _hoisted_9, _toDisplayString(_unref(t)('articles_in_section')), 1),
        _createElementVNode("ul", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(faqSectionArticlesStore).data, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.id
            }, [
              _createVNode(CardArticle, { article: item }, null, 8, ["article"])
            ]))
          }), 128))
        ]),
        (_unref(faqSectionArticlesStore).meta.total_pages > 1)
          ? (_openBlock(), _createBlock(_component_AppPagination, {
              key: 0,
              total: _unref(faqSectionArticlesStore).meta.total,
              "per-page": _unref(faqSectionArticlesStore).meta.per_page,
              page: _unref(faqSectionArticlesStore).meta.page,
              onChange: handlePageChange
            }, null, 8, ["total", "per-page", "page"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(ThinkHelpful, {
        modelValue: article.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((article).value = $event))
      }, null, 8, ["modelValue"])
    ])
  ]))
}
}

})